// extracted by mini-css-extract-plugin
export default {"atlas":"index_atlas_rD2vH","pic":"index_pic_hFbW0","txt":"index_txt_d82nF","pagenum":"index_pagenum_2k6FI","num":"index_num_Fn2TW","title":"index_title_sWQQZ"};